import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'

import App from './App.tsx'

import './index.css'

// 프로덕션 모드에서만 Sentry 초기화
if (import.meta.env.PROD) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true
      })
    ],
    // Performance Monitoring
    tracesSampleRate: 0.1, // 10%의 트랜잭션만 추적
    // Session Replay
    replaysSessionSampleRate: 0.1, // 10%의 세션만 기록
    replaysOnErrorSampleRate: 1.0 // 에러 발생 시 100% 기록
  })
}

createRoot(document.getElementById('root')!).render(<App />)
